export interface IFeatureData {
  name: string;
  description: string;
  isOn: boolean;
  isEditable: boolean;
}

export interface IFeatureGlobalData extends IFeatureData {
  roles: IFeatureRoleData[];
  identities: IFeatureIdentityData[];
}

export interface IFeatureRoleData extends IFeatureData {
  roleId: string;
  roleName: string;
  compositeKey: string;
}

export interface IFeatureIdentityData extends IFeatureData {
  identityId: string;
  identityName: string;
  identityEmail: string;
  compositeKey: string;
}

// The Response is the return value of API call. The response has the same shape as IFeatureData
export type IFeatureResponse = IFeatureGlobalData;

//We can convert from IFeatureResponse to IFeatureGlobalData
export const convertFromIFeatureResponseToIFeatureGlobalData = (response: IFeatureResponse[]): IFeatureGlobalData[] =>
  response.map((r: IFeatureResponse): IFeatureGlobalData => r);

export interface IUpdateFeatureRequest {
  name: string;
  isOn: boolean;
}

export interface ICreateFeatureRoleRequest extends IUpdateFeatureRequest {
  roleId: string;
}

export interface IUpdateFeatureRoleRequest extends IUpdateFeatureRequest {
  roleId: string;
}

export interface IDeleteFeatureRoleRequest {
  name: string;
  roleId: string;
}

export interface ICreateFeatureIdentityRequest extends IUpdateFeatureRequest {
  identityId: string;
}

export interface IUpdateFeatureIdentityRequest extends IUpdateFeatureRequest {
  identityId: string;
}

export interface IDeleteFeatureIdentityRequest {
  name: string;
  identityId: string;
}
